export enum NetworkError {
  MidiDownloadFailed = 'midi-download-failed',
  MidiFileParseFailed = 'midi-file-parse-failed', // technically not a network error...
  MP3DownloadFailed = 'mp3-download-failed',
  MP3GenerationFailed = 'mp3-generation-failed',
  TextDownloadFailed = 'text-download-failed',
  TextFileParseFailed = 'text-file-parse-failed',
  VideoLoadFailed = 'video-load-failed', // a practice video: the YouTube API or the video did not load (offline)
  VideoUnavailable = 'video-unavailable', // a practice video YouTube will not play: a bad id, removed, or not embeddable
  Unknown = 'unknown',
}
